module.exports = __webpack_public_path__ + "media/excellusbcbs-member@lg-b350ebc6eebc20c851bb1ea02b87b3d6.jpg";